(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('focusin', (event) => {
    const item = event.target.closest('.collection-blog .slider__item');
    if (!item) return;
    const slider = item.closest('.slider');
    const itemBounds = item.getBoundingClientRect();
    const sliderBounds = slider.getBoundingClientRect();
    if (itemBounds.left < sliderBounds.left || itemBounds.right > sliderBounds.right) {
      item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.collection-blog__nav button');
    if (!button || button.disabled || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const carousel = button.closest('carousel-slider');
    const slider = carousel.querySelector('.slider');
    const items = carousel.querySelectorAll('.slider__item');
    if (items.length < 2) return;
    event.preventDefault();
    event.stopPropagation();
    const span = Math.abs(items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left);
    const count = typeof theme !== 'undefined' && theme.settings.sliderItemsPerNav === 'page'
      ? Math.max(1, Math.round(slider.clientWidth / span)) : 1;
    let direction = button.name === 'next' ? 1 : -1;
    if (getComputedStyle(slider).direction === 'rtl') direction *= -1;
    slider.scrollBy({ left: span * count * direction, behavior: 'instant' });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
